import React, { ChangeEvent } from "react"

import {
	Box,
	FormControl,
	MenuItem,
	Typography,
} from "@mui/material"
import { ExpandMore } from "@mui/icons-material"

import Chart from "chart.js/auto"
import "chart.js"

import { theme } from "index"
import { customColors } from "customColors"

import { SbSelect } from "components/commons/sb-select"
import {
	DashboardFinancialIndicatorsData,
	DashboardFinancialIndicatorsPeriods,
} from "components/dashboard/dashboard-financial-indicators/models"

export interface DashboardFinancialIndicatorsProps
{
	data: DashboardFinancialIndicatorsData,
}
export interface DashboardFinancialIndicatorsState
{
	selectedFilter: string
}
export class DashboardFinancialIndicators extends React.Component<DashboardFinancialIndicatorsProps, DashboardFinancialIndicatorsState>
{
	private palette = theme.palette;
	private chartRef: React.RefObject<HTMLCanvasElement> = React.createRef();
	private myChart: Chart | null = null;
	private myvalue: DashboardFinancialIndicatorsPeriods | "" = DashboardFinancialIndicatorsPeriods.SEI_MESI;
	private myData: DashboardFinancialIndicatorsData | null = null;
	private myLabels: string[] | undefined = undefined;
	private earnings: number[] = [];
	private isSmallScreen: boolean = window.innerWidth < 1024;

	dataMyData = {
		month: {
			revenue: 	[1000],
			expenses: 	[2300],
		},
		three_months: {
			revenue: 	[1000, 2100, 3420],
			expenses: 	[2300, 3420, 4002]
		},
		six_months: {
			revenue: 	[1000, 2100, 3420, 6650, 4100, 4120],
			expenses: 	[2300, 3420, 4002, 2112, 3451, 3440]
		},
		year: {
			revenue: 	[1000, 2100, 3420, 6650, 4100, 4120, 1000, 2100, 3420, 6650, 4100, 4120],
			expenses: 	[2300, 3420, 4002, 2112, 3451, 3440, 2300, 3420, 4002, 2112, 3451, 3440]
		}
	}
	dataMyLabels = {
		month: ['Dicembre'],
		three_months: ['Ottobre', 'Novembre', 'Dicembre'],
		six_months: ['Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
		year: ['Gennaio', 'Febbario', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
	}

	public componentDidMount()
	{
		this.props.data.revenue.forEach((monthlyRevenue, month) => {
			this.earnings[month] = monthlyRevenue - this.props.data.expenses[month]
		});
		this.myLabels = this.dataMyLabels.six_months
		this.createChart()
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount()
	{
		if(this.myChart) {
			this.myChart.destroy()
		}
		window.removeEventListener("resize", this.handleResize)
	}

	handleResize = () => {
		if(this.myChart) {
			this.myChart.resize()
		}
	}

	createChart = () => {
		const canvas = this.chartRef.current;
		if (canvas) {
			const ctx = canvas.getContext('2d');
			if (ctx) {
				if (this.myChart) {
					this.myChart.destroy();
				}

				this.myChart = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: this.myLabels,
						datasets: [
							{
								label: 'Entrate',
								data: this.props.data.revenue,
								backgroundColor: "rgb(12,140,140)",
								borderColor: "rgb(12,140,140)",
								categoryPercentage: .3,
								barPercentage: .8,
							},
							{
								label: 'Spese',
								data: this.props.data.expenses,
								backgroundColor: "rgb(228,76,84)",
								borderColor: "rgb(228,76,84)",
								categoryPercentage: .3,
								barPercentage: .8,
							},
							{
								label: 'Profitti',
								data: this.earnings,
								backgroundColor: "rgb(4,164,228)",
								borderColor: "rgb(4,164,228)",
								categoryPercentage: .3,
								barPercentage: .8,
							}
						]
					},
					options: {
						maintainAspectRatio: false,
						responsive: true,
						scales: {
							x: {
								grid: {
									display: false,
								},
							},
						},
						plugins: {
							legend: {
								display: false,
							},
						},
					}
				});
			}
		}
	}

	private convertStringToEnumValue = (stringValue: string): DashboardFinancialIndicatorsPeriods => {
		for (const enumValue of Object.values(DashboardFinancialIndicatorsPeriods)) {
			if (stringValue === enumValue) {
				return enumValue
			}
		}

		throw new Error(`The string value "${stringValue}" is not a valid enum value.`);
	};

	private handleChange = (event: React.ChangeEvent<{ value: string }>) => {
		this.myvalue = this.convertStringToEnumValue(event.target.value)
		switch(this.myvalue) {
			case DashboardFinancialIndicatorsPeriods.MESE:
				this.myData = this.dataMyData.month
				this.myLabels = this.dataMyLabels.month
				break;
			case DashboardFinancialIndicatorsPeriods.TRE_MESI:
				this.myData = this.dataMyData.three_months
				this.myLabels = this.dataMyLabels.three_months
				break;
			case DashboardFinancialIndicatorsPeriods.SEI_MESI:
				this.myData = this.dataMyData.six_months
				this.myLabels = this.dataMyLabels.six_months
				break;
			case DashboardFinancialIndicatorsPeriods.ANNO:
				this.myData = this.dataMyData.year
				this.myLabels = this.dataMyLabels.year
		}
		this.earnings = []
		this.myData.revenue.forEach((monthlyRevenue, month) => {
			this.earnings[month] = monthlyRevenue - this.props.data.expenses[month]
		});

		this.setState({
			selectedFilter: event.target.value,
		}, () => {
			if (this.myChart && this.myData) {
				this.myChart.data.labels = this.myLabels;
				this.myChart.data.datasets[0].data = this.myData.revenue;
				this.myChart.data.datasets[1].data = this.myData.expenses;
				this.myChart.data.datasets[2].data = this.earnings;
				this.myChart.update();
			}
		});
		// FARE LA CHIAMATA PER AGGIORNARE I DATI
	}

	render()
	{

		return (
			<Box sx={{ backgroundColor: this.palette.background.default, maxHeight: '780px', pb: 5 }}>
				<header>
					<Box sx={{
						backgroundColor: customColors.storebookDarkGreen,
						paddingLeft: 3,
						paddingY: 2,
						color: 'white',
						textAlign: 'left'
					}}>
						<Typography fontSize={16}>
							Indicatori finanziari
						</Typography>
					</Box>
				</header>

				<div style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: '10px',
				}}>
					<div></div>
					<FormControl sx={{
						m: 1,
						minWidth: 120,
					}} size="small">
						<SbSelect
							variant="outlined"
							size="small"
							IconComponent={ExpandMore}
							value={this.myvalue}
							onChange={(event) => {
								this.handleChange(event as ChangeEvent<{ value: string; }>)
							}}>
							{Object.values(DashboardFinancialIndicatorsPeriods)
								.map((filterValue, index) => (<MenuItem value={filterValue} key={index}>{filterValue}</MenuItem>))}
						</SbSelect>
					</FormControl>
				</div>

				<div style={{
					width: '90%',
					height: this.isSmallScreen ? '300px' : '500px',
					margin: '0 auto'
				}}>
					<canvas ref={this.chartRef}></canvas>
				</div>

			</Box>
		)
	}
}
